<template>
  <div id="account-usage">
    <v-row class="pt-8">
      <v-col cols="12" lg="4">
        <account-plans
          :product="selectedProduct"
          :package-types="packageTypes"
          @update-product="onUpdateProduct"
        />
      </v-col>
      <v-col cols="12" lg="8">
        <account-metrics :selectedProduct="selectedProduct" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AccountPlans from "./AccountPlans.vue";
import AccountMetrics from "./AccountMetrics.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import constants from "@core/config/constants.js";
import isEmpty from "lodash/isEmpty";

const { MAROPOST_PRODUCTS, PRODUCT_IDENTFIERS } = constants;

export default {
  name: "AccountUsage",
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    AccountMetrics,
    AccountPlans
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      // By default marketing details for an account are show here
      selectedProduct: MAROPOST_PRODUCTS.marketingCloud
    };
  },
  computed: {
    ...mapGetters({
      account: "auth/account",
      packageFeatures: "auth/packageFeatures",
      subscriptionDetails: "auth/serviceCloudPackage"
    }),
    packageTypes() {
      return {
        marketingCloud: this.marketingPackageType,
        serviceCloud: this.serviceCloudPackageType
      };
    },
    marketingPackageType() {
      if (this.packageFeatures && this.packageFeatures.account_setting) {
        return this.packageFeatures.account_setting.package_type;
      }
    },
    currentCustomerId() {
      let customerId = this.account.current.customer_id;

      if (!customerId && !isEmpty(this.account.list)) {
        const idx = this.account.list.findIndex(
          account => account.id == this.account.id
        );

        if (idx !== -1) customerId = this.account.list[idx].customer_id;
      }

      return customerId;
    },
    serviceCloudPackageType() {
      return this.subscriptionDetails.package_type || "";
    }
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    ...mapActions({
      getServiceCloudPackage: "auth/getServiceCloudPackage"
    }),
    ...mapMutations({
      setServiceCloudPackage: "auth/setServiceCloudPackage"
    }),
    onUpdateProduct(product) {
      this.selectedProduct = product;
      this.$router.push({ query: { product } });
    },
    openCurrentProductUsage() {
      const { query } = this.$route;

      if (query.product) {
        const isProductValid = Object.values(MAROPOST_PRODUCTS).some(
          value => value === query.product
        );

        if (isProductValid) this.onUpdateProduct(query.product);
      }
    },
    async getSubscriptionDetails() {
      const params = { product_eq: PRODUCT_IDENTFIERS.msc.id };

      await this.getServiceCloudPackage({
        customerId: this.currentCustomerId,
        params
      });
    }
  },
  /**
  |--------------------------------------------------
  | Mounted lifecycle hook
  |--------------------------------------------------
  */
  mounted() {
    this.openCurrentProductUsage();
    this.setServiceCloudPackage({})
    this.getSubscriptionDetails();
  }
};
</script>
